import script from "./EncounterEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./EncounterEditor.vue?vue&type=script&setup=true&lang=js"

import "./EncounterEditor.vue?vue&type=style&index=0&id=21a3a4d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a3a4d6"]])

export default __exports__